export default "__VITE_ASSET__$l6h06wu__"